import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import {
  NbAuthComponent,
  NbLoginComponent,
  NbLogoutComponent,
  NbRegisterComponent,
  NbRequestPasswordComponent,
  NbResetPasswordComponent,
} from '@nebular/auth';
import { RoleGuard } from './@core/auth/auth.roleguard.service';

const routes: Routes = [
	{
		path: '',
		loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule)
  },
  {
    path: 'overview-map',
		loadChildren: () => import('./harvest-engine/modules/overview-map/overview-map.module').then(m => m.OverviewMapModule)
  },
  // {
  //   path: 'overview-map',
  //   loadChildren: 'app/harvest-engine/modules/overview-map/overview-map.module#OverviewMapModule',
  // },
  {
    path: 'public',
    loadChildren: () => import('./public/public.module').then(m => m.PublicModule)
  },
  	
  // Reporting
  {
    path: 'reports',
    loadChildren: () => import('./reports/report.module').then(m => m.ReportModule),
    outlet: 'reports'
  },
	{
		path: '**',
		redirectTo: '404',
		pathMatch: 'full'
  },
];

const config: ExtraOptions = {
    useHash: true,
    // relativeLinkResolution: 'legacy'
};

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload'})],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
